import Component from "gia/Component";
import lottie from "lottie-web";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    //! VARS
    this.FX = {
      text: new SplitText(this.ref.titleIntro[0], { type: "lines" }),
    };

    this._fx();
  }

  _fx() {
    this.animate();
    this.animationLottie();
    this.listener();
  }

  animate() {
    this.animation = gsap.timeline({
      onStart: () => this.animLottie.play(),
    });

    this.animation.add([
      gsap.fromTo(
        this.FX.text.lines,
        {
          y: 25,
          autoAlpha: 0,
        },
        {
          duration: 1,
          y: 0,
          autoAlpha: 1,
          ease: "cubic.out",
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.ref.cta,
        {
          y: 15,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          ease: "cubic.out",
          duration: 0.6,
          stagger: 0.15,
          delay: 0.5,
        }
      ),
    ]);
  }

  animationLottie() {
    this.animLottie = lottie.loadAnimation({
      container: this.ref.pattern[0], // the dom element that will contain the animation
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: config.pathAssets + "/animations/pattern.json", // the path to the animation json
    });
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: "top 60%",
    });
  }

  unmount() {
    this.stListener.kill();
  }
}
